import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-searchBar",
  "use": "icon-searchBar-usage",
  "viewBox": "0 0 1177 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1177 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-searchBar\"><path d=\"M1126.4 281.6H51.2v460.8h1075.2V281.6z m-51.2 51.2v358.4H102.4V332.8h972.8z\" fill=\"#3D3E40\" p-id=\"19562\" /><path d=\"M320 396.8a102.4 102.4 0 1 0 0 204.8 102.4 102.4 0 0 0 0-204.8z m0 25.6a76.8 76.8 0 1 1 0 153.6 76.8 76.8 0 0 1 0-153.6z\" fill=\"#3D3E40\" p-id=\"19563\" /><path d=\"M393.0624 554.1376l51.2 51.2-18.1248 18.1248-51.2-51.2z\" fill=\"#3D3E40\" p-id=\"19564\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol